import { Injectable, Input } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ServicePlus } from '../models/ServicePlus';
import { ADN_PLUS } from "../models/ADN_PLUS";
import { Condition } from "../models/Condition";
import { UtilService } from './util.service';
import { catchError, map } from 'rxjs/operators';
import { AuthService, BreadCrumbService, HttpService } from '.';
import { CtMenuComponent } from '../controls/ct-menu/ct-menu.component';

@Injectable()
export class MenuService {

  @Input() isHorizontal = false;
  private baseUrl: string = HttpService.ENDPOINT + '/api/Menu';
  private menu: any;
  private applicatonMenu: any[];
  public menuComponent : CtMenuComponent;


  constructor(private httpService: HttpService, private router: Router, private breadcrumbService: BreadCrumbService, private utilService: UtilService, private authService: AuthService) {
    this.applicatonMenu = [];
  }

  getMenuOptions(): Observable<any> {
    this.httpService.useApikey = false;
    return this.httpService.get(this.baseUrl).pipe(
      map(this.extractMenuData),
      map(data => {
        return data;
      }),
      catchError((error: any) => {
        return throwError(this.applicatonMenu);
      }))
  }

  setMenuComponent(menuComponent: any) {
    this.menuComponent = menuComponent;
  }

  getFavoriteOptions(): Observable<any> {
    let user = JSON.parse(localStorage.getItem('loggedUser'));
    let userCode = user.ArrayEntities.List.find(x => {
      return x.Name === '' ? (x.Alias === 'USER_ID') : (x.Name === 'USER_ID');
    }).Value;
    let service = {
      "Entity": "SG_VIEWS_FAV_PF",
      "OperationName": "RET_SG_VIEWS_FAV_PF",
      "Status": 1,
      "Type": 1,
      "Source": "uil2",
      "UserCode": userCode,
      "UserPassword": null,
      "Message": null,
      "Conditions": {
        "Data": [
          {
            "Name": "USER_ID",
            "Alias": "USER_ID",
            "Value": userCode,
            "Type": 1
          },
          {
            "Name": "VIEW_ID",
            "Alias": "VIEW_ID",
            "Value": null,
            "Type": 1
          }
        ]
      },
      "Data": null
    }
    return this.httpService.post(HttpService.ENDPOINT + '/api/v1/CrudService/RetrieveListWithOperation', service)
      .pipe(
        map(this.extractData),
        map(data => {
          return data;
        }),
        catchError((e: any) => {
          return of(this.applicatonMenu);
        }));
  }

  addToFavorites(viewId) {
    let user = JSON.parse(localStorage.getItem('loggedUser'));
    let userCode = user.ArrayEntities.List.find(x => {
      return x.Name === '' ? (x.Alias === 'USER_ID') : (x.Name === 'USER_ID');
    }).Value;
    let serv = new ServicePlus('SG_VIEWS_FAV_PF', 'CRE_SG_VIEWS_FAV_PF');
    let adn = new ADN_PLUS();
    serv.Data.push(adn);
    serv.Data[0].ArrayEntities.addEntityField({ Name: 'USER_ID', Value: userCode });
    serv.Data[0].ArrayEntities.addEntityField({ Name: 'VIEW_ID', Value: "10" });

    return this.httpService.post(HttpService.ENDPOINT + '/api/v1/CrudService/CreateDefaultWithEntity', serv).subscribe(x => {
      x = JSON.parse(x);
    },
      (err) => {
        let errorMessage
      }
    )
  }

  removeFromFavorites(viewId) {
    let user = JSON.parse(localStorage.getItem('loggedUser'));
    let userCode = user.ArrayEntities.List.find(x => {
      return x.Name === '' ? (x.Alias === 'USER_ID') : (x.Name === 'USER_ID');
    }).Value;
    let serv = new ServicePlus('SG_VIEWS_FAV_PF', 'DEL_SG_VIEWS_FAV_PF');
    serv.Conditions = new Condition();
    serv.Conditions.addEntityField({ Name: 'USER_ID', Value: userCode });
    serv.Conditions.addEntityField({ Name: 'VIEW_ID', Value: "10" });

    return this.httpService.post(HttpService.ENDPOINT + '/api/v1/CrudService/DeleteWithOperation', serv).subscribe(x => {
      x = JSON.parse(x);
    },
      (err) => {
        let errorMessage
      }
    )
  }

  private extractMenuData = (res: any) => {
    let body;

    try {
      body = JSON.parse(res);
    } catch (error) {
      body = res;
    }

    this.menu = body;
    // setTimeout(() => this.addBreadCrumb());
    return body;
  }

  private extractData = (res: any) => {
    let body = JSON.parse(res);
    return body;
  }

  private getHeaders() {
    let headers = new Headers();
    headers.append('Accept', 'application/json');

    return headers;
  }

  isViewReferenced(viewId: string) {
    return this.breadcrumbService.isViewReferenced(viewId);
  }


  logOut() {
    this.authService.logOut();
    this.router.navigate(['/login'])
  }

  /**
   * Revision del breadcrumb en caso de acceso directo por URL
   * @param viewNode CtView
   */
  addBreadCrumb(viewNode: any = null) {
    let route = this.router.url.substr(1).split('/');

    if (route[1] === 'dashboard')
      return;

    if (viewNode && this.breadcrumbService.isViewMapped(viewNode.getId())) {
      this.utilService.checkStack(viewNode);
      return;
    }

    let ctrlCode = route[2].split('?')[0];

    if (ctrlCode && this.menu) {
      let breadCrumb;
      let routerLink;
      let ctrl = null;

      if (ctrlCode === 'CtSigmaContainer') {
        breadCrumb = this.getBreadCrumb(route[3])
        routerLink = "/home/ssvmn/CtSigmaContainer/";
      }
      else {
        breadCrumb = this.getBreadCrumb(ctrlCode)
        routerLink = 'home/ssvmn/';
        ctrl = this.utilService.getComponentRef(ctrlCode);
      }

      if (breadCrumb) {
        if (!this.breadcrumbService.isViewMapped(breadCrumb.navigateTo))
          this.breadcrumbService.addBreadCrumb(breadCrumb.text, routerLink + breadCrumb.navigateTo, true, ctrl);
      }
    }
  }

  /**
   * Navegacion por menu
   * @param title Titulo de la nueva vista
   * @param url Codigo de la nueva vista
   */
  navigateTo(title: string, url: string) {
    let routerLink = 'home/view/';
    // Not using on SVA
    // if (url[0] === "$") {
    //   //"$[VCD_BIT_ACTIVIDADES;CT.ctBitacoraActividades/CargarFecha()]"
    //   url = url.replace(";CT", "").replace("; CT", "").replace(".", "/").replace("$", "").replace("[", "").replace("]", "");
    //   routerLink = '/home/ssvmn/CtSigmaContainer/';
    // }
    // else if (url.indexOf("PA_") !== -1)
    //   routerLink = '/home/ssvmn/CtFormsContainer/';

    // this.breadcrumbService.clear();
    this.breadcrumbService.navigateTo(routerLink, url, title, null, true);
  }

  getViewTitle(viewName): string {
    let breadCrumb = this.getBreadCrumb(viewName);

    if (breadCrumb)
      return breadCrumb['text'];
    return null;
  }

  private getBreadCrumb(viewName): any {
    for (let role of this.menu) {
      for (let node of role.childs) {
        for (let option of node.childs) {
          if (option.navigateTo[0] === "$") {
            let oldViewName = option.navigateTo.replace(";CT", "").replace("; CT", "").replace(".", "/").replace("$", "").replace("[", "").replace("]", "");
            if (oldViewName.includes(viewName))
              return { text: option.text, navigateTo: oldViewName }
          } else
            if (viewName === option.navigateTo)
              return { text: option.text, navigateTo: option.navigateTo }
        }
      }
    }
  }

  flushUserMenu() {
    this.menuComponent.ngOnInit();
  }

  resetActiveMenuChildByCode(viewCode : string): void {
    let activeChild = this.menuComponent.activeChild;
    if(!activeChild) return;
    this.menuComponent.getNodes().forEach((node, nodeIndex) => {
      node.childs.forEach((child, childIndex) => {
        if(child.navigateTo == viewCode) {
          activeChild.childIndex = childIndex;
          activeChild.nodeIndex = nodeIndex;
        }
      })
    });
    this.menuComponent.activeChild = activeChild;
  }
}